import { FormElement, IFormElementProperties } from '@vfde-brix/ws10/form-element';
import { IInputConfiguration } from '../../../interface';
import { LmsHtmlId } from '../../../enums/elementId';
import { mountFormElement } from '../../../components/formElement';
import { mountButton } from '../../../components/button';
import {
    EMAIL_VALIDATION_CONFIG,
    MAX_LENGTH_50_VALIDATION_CONFIG,
    REQUIRED_VALIDATION_CONFIG,
    SECURE_VALUE_VALIDATION_CONFIG,
} from '../../../constants';
import * as mapDispatch from '../action';
import { formValidation } from '@vfde-brix/ws10/validation';

type Actions = typeof mapDispatch;

const markMandatoryInput = (input: FormElement) => {
    const markerString = ' <span class="text-primary-100">*</span>';
    const inputProps: IFormElementProperties = input.getProperties();

    const updatedProps = {
        ...inputProps,
        stdLabel: inputProps?.stdLabel + markerString,
    };

    input.update(updatedProps);
};

export const mountLmsForm = (actions: Actions) => {
    const formFields: FormElement[] = [];

    const inputConfigurations: IInputConfiguration[] = [
        {
            id: LmsHtmlId.WRAPPER_INPUT_GENDER,
            onChange: (_: Event, value: string) => actions.changeLmsInput({ salutation: value }),
            validation: [],
        },
        {
            id: LmsHtmlId.WRAPPER_INPUT_FIRSTNAME,
            onChange: (event: Event, value: string) => { actions.changeLmsInput({ firstName: value }); },
            validation: [
                REQUIRED_VALIDATION_CONFIG,
                SECURE_VALUE_VALIDATION_CONFIG,
                MAX_LENGTH_50_VALIDATION_CONFIG,
            ],
        },
        {
            id: LmsHtmlId.WRAPPER_INPUT_LASTNAME,
            onChange: (event: Event, value: string) => { actions.changeLmsInput({ lastName: value }); },
            validation: [
                REQUIRED_VALIDATION_CONFIG,
                SECURE_VALUE_VALIDATION_CONFIG,
                MAX_LENGTH_50_VALIDATION_CONFIG,
            ],
        },
        {
            id: LmsHtmlId.WRAPPER_INPUT_EMAIL,
            onChange: (event: Event, value: string) => { actions.changeLmsInput({ email: value }); },
            validation: [
                REQUIRED_VALIDATION_CONFIG,
                SECURE_VALUE_VALIDATION_CONFIG,
                EMAIL_VALIDATION_CONFIG,
                MAX_LENGTH_50_VALIDATION_CONFIG,
            ],
        },
    ];

    for (const { id, onChange, validation } of inputConfigurations) {
        const formElement = mountFormElement(id, onChange, validation);

        if (formElement) {
            validation.includes(REQUIRED_VALIDATION_CONFIG) && markMandatoryInput(formElement);
            formFields.push(formElement);
        }
    }

    const submitButton = mountButton(
        LmsHtmlId.WRAPPER_BTN_LMS_SUBMIT,
        actions.submitLmsForm,
    );

    if (submitButton){
        formValidation({ formFields, submitButton });
    }

    return {
        formFields,
        submitButton,
    };
};
